import React from "react";
import { gql } from "@apollo/client";
import { toast } from "react-toastify";
import ToastView, { defaultToastProps } from "../../../../components/newcomponents/ToastView";
import swal from "@sweetalert/with-react";
import AlertView from "../../../../components/newcomponents/AlertView";
import { errorToDisplay } from "../../../../helper/CommonFuncs";
import { fetchMutation, fetchQuery } from "../../../../actions";
import { ShowAlert } from "../../../../common/alert";

const showSwalAlert = (titleText, contentText, callback) =>
   swal(<AlertView titleText={titleText} contentText={contentText} showClose={false} onAction={callback} />, {
      buttons: false,
   });

const showToast = (text, type) => toast(<ToastView text={text} type={type} />, defaultToastProps);

export const postOptTapped = (
   opt,
   postIndex,
   contentList,
   setContentList,
   sendContent,
   callback = () => {},
   callBackUnset = () => {}
) => {
   var listData = contentList.map((s) => s);
   let obj = listData[postIndex];
   if (opt.id === 2) {
      let cText = obj.isPrintable ? "Restrict" : "Allow";
      showSwalAlert(obj?.title, `${cText} download for this content?`, (btnData) => {
         swal.close();
         if (btnData.id === "alert-confirm-button") {
            let params = { updatePrintStatus: true, media: { mediaId: obj?.id, isPrintable: !obj.isPrintable } };
            fetchMutation(
               UPDATE_MEDIA_DOWNLOAD_STATUS,
               params,
               (res) => {
                  showToast("Successfully updated");
                  obj.isPrintable = !obj.isPrintable;
                  listData[postIndex] = obj;
                  setContentList(listData);
               },
               (err) => {
                  let errMsg = errorToDisplay(err);
                  ShowAlert(errMsg, "error");
               }
            );
         }
      });
   } else if (opt.id === 1) {
      sendContent && sendContent(obj);
   } else if (opt.id === 3) {
      let key = "mediaId";
      if (obj?.type === "text" || obj?.type === "item") {
         key = "itemId";
      }
      const titleObj = obj?.title;
      const title = titleObj?.length > 80 ? titleObj?.substring(0, 80) + "..." : titleObj;
      showSwalAlert(title, "Are you sure you want to delete this content?", (btnData) => {
         swal.close();
         if (btnData.id === "alert-confirm-button") {
            callback();
            let params = { isDelete: true, media: { [key]: obj?.id } };
            fetchMutation(
               UPDATE_MEDIA_STATUS,
               params,
               (res) => {
                  callBackUnset();
                  showToast("Successfully deleted");
                  listData.splice(postIndex, 1);
                  setContentList(listData);
               },
               (err) => {
                  let errMsg = errorToDisplay(err);
                  ShowAlert(errMsg, "error");
               }
            );
         }
      });
   }
};

export const fetchSignedUrlContentShare = (data, callBack) => {
   fetchQuery(
      GET_THUMBNAIL_SIGNED_URL,
      data,
      (res) => {
         return callBack(res.data?.getSignedURL?.url);
      },
      (err) => {
         return console.log("Content load error", err);
      }
   );
};

export const GET_PATIENT_CONTENT = gql`
   query GetPatientContentQuery(
      $offset: Int!
      $limit: Int!
      $user_id: String!
      $search: String!
      $patientOnly: Boolean!
      $providerOnly: Boolean!
      $allowBreadcrumb: Boolean
      $directoryId: String
      $allowDirectory: Boolean
   ) {
      getPatientContent(
         offset: $offset
         limit: $limit
         user: { id: $user_id }
         search: $search
         patientOnly: $patientOnly
         providerOnly: $providerOnly
         allowBreadcrumb: $allowBreadcrumb
         directoryId: $directoryId
         allowDirectory: $allowDirectory
      ) {
         totalCount
         breadCrumbData {
            directoryId
            name
         }
         contents {
            title
            type
            id
            createdAt
            isPrintable
            isDoctorsOnly
            provider {
               name {
                  fullName
               }
               contactInformation {
                  email
               }
               id
            }
            patient {
               id
               name {
                  fullName
               }
               contactInformation {
                  email
               }
            }
            views {
               viewedAt
               viewer {
                  id
                  name {
                     fullName
                  }
                  contactInformation {
                     email
                  }
               }
            }
            hasThumbnail
            loves
            mentions
            tags
            hospital {
               id
               name
            }
            description
            healthSystem {
               id
               name
               patientIdentifiers {
                  number
                  type
                  authority
               }
            }
         }
      }
   }
`;

export const GET_THUMBNAIL_SIGNED_URL = gql`
   query GetSignedURL($thumbnail: Boolean!, $content: ContentInput!, $includeTranscription: Boolean) {
      getSignedURL(thumbnail: $thumbnail, content: $content, includeTranscription: $includeTranscription) {
         url
         thumbnailUrl
         Transcription
         dataCount
      }
   }
`;

export const GET_CONTENT_SIGNED_URL = gql`
   query GetSignedURL($thumbnail: Boolean!, $content: ContentInput!) {
      getSignedURL(thumbnail: $thumbnail, content: $content) {
         url
      }
   }
`;

export const GET_PATIENT_CONTENT_SEENBY_LIST = gql`
   query GetPatientContentSeenByQuery(
      $offset: Int!
      $limit: Int!
      $content: ContentInput
      $user: UserInput
      $providerOnly: Boolean
   ) {
      getPatientContent(offset: $offset, limit: $limit, content: $content, user: $user, providerOnly: $providerOnly) {
         contents {
            views {
               viewer {
                  id
                  colorCode
                  contactInformation {
                     email
                     mobileNumber
                  }
                  name {
                     initials
                     fullName
                  }
               }
               viewedAt
            }
         }
      }
   }
`;

export const CREATE_CONTENT = gql`
   mutation Mutation($media: ContentInput) {
      createContent(media: $media) {
         id
         signedUrl {
            url
         }
      }
   }
`;

export const UPDATE_ITEM_VIEWED_STATUS = gql`
   mutation AddActivity($options: AddActivityOptions) {
      addActivity(options: $options) {
         status {
            code
            success
            message
         }
      }
   }
`;

export const UPDATE_MEDIA_DOWNLOAD_STATUS = gql`
   mutation AddPatient($updatePrintStatus: Boolean, $media: ContentInput) {
      updateMedia(updatePrintStatus: $updatePrintStatus, media: $media) {
         message
      }
   }
`;

export const UPDATE_MEDIA_STATUS = gql`
   mutation UpdateMedia($isActivity: Boolean, $isDelete: Boolean, $media: ContentInput) {
      updateMedia(isActivity: $isActivity, isDelete: $isDelete, media: $media) {
         message
      }
   }
`;
